import React, { Component }    from 'react';
import Tags                    from '../Tags';
import PlaceBody               from './PlaceBody';
import { displayDistance }     from '../../classes/Distance';

class PlaceInfo extends Component
{
    renderPlace = (place) =>
    {
        return (
            <div>
                <PlaceBody body={ place.body } />
                <Tags tags={ place.tags } goToFilter={ this.props.goToFilter } />
            </div>
        );
    };

    renderTrail = (trail) =>
    {
        return (
            <div className="trail-summary">
                <p className="trail-sub-summary">{ trail.summaryTime }</p>
                <p className="trail-sub-summary">{ trail.summaryDistance }</p>
                <p className="trail-summary">{ trail.summary }</p>
                <p className="trail-additional-info">{ trail.additionalInfo }</p>
            </div>
        )
    };

    render = () =>
    {
        let { place } = this.props;
        let distance;

        if (place.distance)
        {
            distance = <p className="place-distance">{ displayDistance(place.distance)} </p>;
        }

        let body;

        if ('trail' === place.type)
        {
            body = this.renderTrail(place);
        }
        else
        {
            body = this.renderPlace(place);
        }

        return (
            <div className="place-info">
                { distance }
                { body }
            </div>
        );
    }
}

export default PlaceInfo;



// WEBPACK FOOTER //
// ./src/components/Place/PlaceInfo.js